export default __webpack_public_path__ + "static/media/ourP3.d73aa84d.png";